// @ts-check
import { getAll, getById } from '../utilities/querySelector';
import { toggleBooleanAttribute } from '../utilities/attributes';

const header = getById( 'site-header' );
const burger = getById( 'mobile-menu-toggle' );
const mobile_menu = getById( 'mobile-menu' );

const scrollDeterminer = new IntersectionObserver( headerScrollHandler, {} );
scrollDeterminer.observe( getById( 'site-header-scroll-indicator' ) );
/**
 * @param {IntersectionObserverEntry[]} entries
 *
 * @return void
 */
function headerScrollHandler( entries ) {
    entries.forEach( entry => {
        header.toggleAttribute( 'data-scrolled', !entry.isIntersecting );
    } );

}

mobile_menu.setAttribute( 'aria-hidden', 'true' );
mobile_menu.setAttribute( 'aria-controlledby', 'mobile-menu-toggle' );
burger.addEventListener( 'click', () => {
    document.body.toggleAttribute( 'data-mobile-menu-open' );
    toggleBooleanAttribute( 'aria-hidden', mobile_menu );
    toggleScroll();
} );

getAll( 'a', header ).forEach( link => link.addEventListener( 'click', function() {
    document.body.removeAttribute( 'data-mobile-menu-open' );
    toggleScroll( false );
} ) );

/**
 * @param  {boolean|undefined} condition
 *
 * @return void
 */
export function toggleScroll( condition = undefined ) {
    document.documentElement.classList.toggle( 'no-scroll', condition );
}